import type React from 'react';
import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { analytics } from '../../services/analytics';
import GoogleCalendarSettingsPage from './calendar/GoogleCalendarSettingsPage';
import GoogleDriveSettingsPage from './drive/GoogleDriveSettingsPage';
import SlackSettingsPage from './slack/SlackSettingsPage';

const SettingsRouter: React.FC = () => {
  const { provider } = useParams();
  const location = useLocation();
  const key = (provider || '').toLowerCase();

  useEffect(() => {
    analytics.viewed(
      'Viewed settings',
      'settings',
      location.pathname,
      {},
      {
        dedupeKey: `viewed-settings:${location.key}`,
      }
    );
  }, [location.key, location.pathname]);

  switch (key) {
    case 'google-calendar':
      return <GoogleCalendarSettingsPage />;
    case 'google-drive':
      return <GoogleDriveSettingsPage />;
    case 'slack':
      return <SlackSettingsPage />;
    default:
      return <Navigate to="/settings/integrations" replace />;
  }
};

export default SettingsRouter;
